import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { PricebookPendingSchedule } from "../../../../types/price-book.type";
import { buildScheduleBarText } from "./scheduleModel";

interface ScheduleBarProps {
  /** The book's schedules waiting for their day, soonest first. */
  pendingSchedules: PricebookPendingSchedule[];
  onOpenSchedules: () => void;
}

/**
 * The blue bar on a book with a draft apply set for a later day. Any edit to the book before then
 * makes the job refuse the schedule, so the bar says so where the edits are made.
 */
export default function ScheduleBar({ pendingSchedules, onOpenSchedules }: ScheduleBarProps) {
  if (pendingSchedules.length === 0) return null;

  return (
    <Alert
      severity="info"
      action={
        <Button color="inherit" size="small" onClick={onOpenSchedules}>
          ดูการตั้งเวลา
        </Button>
      }
    >
      <Typography variant="body2" fontWeight={600}>
        {buildScheduleBarText(pendingSchedules)}
      </Typography>
      <Typography variant="caption">
        ถ้าแก้สมุดนี้ก่อนถึงวัน ระบบจะไม่นำการตั้งเวลาไปใช้ (สถานะชนกัน)
      </Typography>
    </Alert>
  );
}
